/**
 * Large circular mic button — grandmother-friendly.
 * Green = idle (tap to start), orange = connecting, pulsing red = active (tap to stop).
 */

import { FC } from "react";
import cn from "classnames";
import "./mic-button.scss";

export type ConnectionState = "disconnected" | "connecting" | "connected";

interface MicButtonProps {
  state: ConnectionState;
  volume: number;
  onTap: () => void;
}

const MicButton: FC<MicButtonProps> = ({ state, volume, onTap }) => {
  const pulseScale = state === "connected" ? 1 + volume * 0.3 : 1;

  return (
    <button
      className={cn("mic-button", state)}
      onClick={onTap}
      aria-label={
        state === "connected" ? "Stop conversation" : "Start conversation"
      }
    >
      <div
        className="mic-button__pulse"
        style={{ transform: `scale(${pulseScale})` }}
      />
      <div className="mic-button__icon">
        {state === "connected" ? (
          // Stop icon
          <svg viewBox="0 0 24 24" width="48" height="48">
            <rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor" />
          </svg>
        ) : (
          // Mic icon
          <svg viewBox="0 0 24 24" width="48" height="48">
            <path
              fill="currentColor"
              d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
            />
          </svg>
        )}
      </div>
    </button>
  );
};

export default MicButton;
